import { HTMLAttributes } from 'react';

type MaxOutWalletAmountButtonProps = Pick<HTMLAttributes<HTMLButtonElement>, 'onClick'>;

const MaxOutWalletAmountButton = (props: MaxOutWalletAmountButtonProps) => {
  return (
    <button {...props} className="text-neutral-50 bg-primary-600 px-[8px] py-[2px] rounded-[4px]">
      MAX
    </button>
  );
};

export { MaxOutWalletAmountButton };
